/**
 * Strip HTML to readable plain text for in-app display when WebView is unreliable (e.g. Modal).
 */
export function htmlToPlainText(html: string): string {
  if (!html || typeof html !== 'string') {return '';}
  let s = html
    .replace(/\r\n/g, '\n')
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<\/(p|div|h[1-6]|li|tr|section|article)>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#(\d+);/g, (_, n) => String.fromCharCode(Number(n)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_, h) => String.fromCharCode(parseInt(h, 16)));
  return s.replace(/\n{3,}/g, '\n\n').trim();
}

/**
 * Text to show for CMS `pages` API HTML: strip tags + entities, with a second pass if markup-only.
 * Use everywhere `content` / `a_content` from the pages API is shown in RN (ScrollView/Text).
 */
export function cmsPageHtmlToDisplayText(html: string): string {
  const plain = htmlToPlainText(html);
  if (plain.length > 0) {return plain;}
  if (!html?.trim()) {return '';}
  return html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
